import { AiOutlineDownload } from "react-icons/ai";
import {
  Typography,
  Button,
  ButtonSwitch,
  Table,
  TableFooter,
  Tag,
  TextField,
} from "components";
import { useEffect, useState } from "react";
import { capitalizeFirstLetter } from "utils/helper";
import { genderOptions, userStatuses } from "utils/constants";

const HighLowAgentTable = ({
  loading,
  agentPerformanceData,
  highLowAgentQuery,
  getAgentPerformanceData,
  downloadAgentPerformance,
  handleHighLowAgentQueryChange,
}) => {
  const getAnonymousStatusText = (value) => {
    value = value?.split("_");
    let newValue = `${capitalizeFirstLetter(
      value[0]?.toLowerCase()
    )} ${value[1].toLowerCase()}`;
    return newValue;
  };

  const getStatusTag = (value) => {
    let val = userStatuses.find((status) => status.mapper === value);
    return val ? (
      <Tag
        text={val.text}
        backgroundColor={val.bgColor}
        textColor={val.color}
      />
    ) : (
      <Tag
        text={getAnonymousStatusText(value)}
        backgroundColor={"#F1F4F9"}
        textColor={"#AAA6A6"}
      />
    );
  };

  const columns = [
    {
      Header: "S/N",
      Cell: ({ row }) => Number(row.id) + 1,
    },
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ value }) => capitalizeFirstLetter(value) || "-",
    },
    {
      Header: "Agent Code",
      accessor: "agentCode",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Gender",
      accessor: "gender",
      Cell: ({ value }) => {
        if (!value) return "";
        const genderOption = genderOptions.find(
          (gender) => gender.value === value
        );
        return genderOption?.label || "";
      },
    },
    {
      Header: "Number of Accounts",
      accessor: "numOfAccounts",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Number of Terminals",
      accessor: "numOfTerminals",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Phone Number",
      accessor: "phoneNumber",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Region",
      accessor: "region",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "State",
      accessor: "state",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => getStatusTag(value),
      customWidth: "10rem",
    },
  ];

  const [tableData, setTableData] = useState(
    agentPerformanceData?.details.content
  );

  const [searchField, setSearchField] = useState("");

  const { category, size, number, agentId } = highLowAgentQuery;

  useEffect(() => {
    getAgentPerformanceData();
    //eslint-disable-next-line
  }, [category, number, size, agentId]);

  useEffect(() => {
    setTableData(agentPerformanceData?.details.content);
  }, [agentPerformanceData?.details.content]);

  const handleSearch = (e) => {
    const val = e.target.value.toLowerCase();
    setSearchField(val);
    setTableData(
      agentPerformanceData?.details?.content.filter(
        ({ name, agentId, phoneNumber, agentCode, email, region, state }) =>
          name?.toLowerCase()?.includes(val) ||
          agentId?.toString()?.toLowerCase()?.includes(val) ||
          phoneNumber?.toLowerCase()?.includes(val) ||
          agentCode?.toString()?.includes(val) ||
          email?.toLowerCase()?.includes(val) ||
          region?.toLowerCase()?.includes(val) ||
          state?.toLowerCase()?.includes(val)
      )
    );
  };

  return (
    <div>
      <Typography state="grey" variant={"body2"}>
        Preview Report Generated
      </Typography>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <ButtonSwitch
          leftLabel="High"
          rightLabel="Low"
          value={category}
          handleClick={() => {
            handleHighLowAgentQueryChange({
              name: "category",
              value: category === 0 ? 1 : 0,
            });

            setSearchField("");
          }}
        />
        <Button
          label="Download Report"
          className={"report-download-cta"}
          endIcon={<AiOutlineDownload />}
          onClick={downloadAgentPerformance}
          disabled={!tableData?.length}
        />
      </div>
      <div className="">
        <div className="d-flex justify-content-between align-items-center my-3">
          <Typography
            variant={"body4"}
            state="primary"
            className={"d-none d-md-block"}
          >
            {category === 0 ? "High" : "Low"} Performing Agents (
            {agentPerformanceData?.details?.totalElements})
          </Typography>

          <TextField
            name="searchField"
            id="searchField"
            value={searchField}
            onChange={handleSearch}
            placeholder={"Search..."}
            size="sm"
            required={false}
            searchField
            className="tiny-bordered-textfield"
          />
        </div>
        <Table columns={columns} data={tableData || []} loading={loading} />
        {tableData?.length && !searchField.length ? (
          <TableFooter
            pageSize={size}
            forcePage={number}
            handleChange={(e) => {
              handleHighLowAgentQueryChange({
                name: "size",
                value: e.target.value,
              });
            }}
            availableDataLength={tableData?.length}
            totalDataLength={agentPerformanceData?.details?.totalElements}
            handlePageClick={(pageNo) => {
              handleHighLowAgentQueryChange({
                name: "number",
                value: pageNo,
              });
            }}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default HighLowAgentTable;
